<template>
    <kt-panel>
        <kt-panel-body>
            <kt-row>
                <div class="align-items-center mt-2 mb-5">
                    <kt-form-label>
                        {{ $t('label.marketing_referral_service_status') }}
                    </kt-form-label>
                    <select 
                        class="form-control"
                        id="referral_service_enabled"
                        name="referral_service_enabled"
                        v-model="referral_service_enabled"
                    >
                        <option
                            v-bind:key="index"
                            v-for="(status, index) in statuses"
                            v-bind:value="status.value"
                        >
                            {{ status.name }}
                        </option>
                    </select>
                </div>
            </kt-row>
            <form class="kt-form" @submit.prevent="edit" id="marketer_specific_setting">
                <kt-form-label>
                    <h5>
                        {{ $t('marketing.marketing_setting.marketing_percent') }}
                    </h5>
                </kt-form-label>
                <kt-row lg="12" md="12" xs="12" class="ml-1">
                    <kt-col lg="4" md="4" xs="12">
                        <kt-form-section>
                            <kt-form-group>
                                <kt-form-label for="marketing_level_1">
                                    {{ $t('marketing.marketing_setting.level_1') }}
                                </kt-form-label>
                                <kt-form-control
                                        type="number"
                                        placeholder="0-100"
                                        name="marketing_level_1"
                                        id="marketing_level_1"
                                        max="100"
                                        v-model="marketer_specific_setting.profit_percent_level_1"
                                >
                                </kt-form-control>
                            </kt-form-group>
                        </kt-form-section>
                    </kt-col>
                    <kt-col lg="4" md="4" xs="12">
                        <kt-form-group >
                            <kt-form-label for="marketing_level_2">
                                {{ $t('marketing.marketing_setting.level_2') }}
                            </kt-form-label>
                            <kt-form-control
                                    type="number"
                                    placeholder="0-100"
                                    name="marketing_level_2"
                                    id="marketing_level_2"
                                    max="100"
                                    v-model="marketer_specific_setting.profit_percent_level_2"
                            >
                            </kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col lg="4" md="4" xs="12">
                        <kt-form-group>
                            <kt-form-label for="marketing_level_3">
                                {{ $t('marketing.marketing_setting.level_3') }}
                            </kt-form-label>
                            <kt-form-control
                                    type="number"
                                    placeholder="0-100"
                                    name="marketing_level_3"
                                    id="marketing_level_3"
                                    max="100"
                                    v-model="marketer_specific_setting.profit_percent_level_3"
                            >
                            </kt-form-control>
                        </kt-form-group>
                    </kt-col>
                </kt-row>
                <kt-row>
                    <div class="d-flex align-items-center mt-0 mb-2">
                        <input ref="custom_wage_marketing"
                               id="checkbox"
                               type="checkbox"
                               v-model="marketer_specific_setting.custom_wage_marketing"
                        >
                        <label class="mt-2 ml-2 " for="checkbox">استفاده از کارمزد اختصاصی نماینده فروش به عنوان پیشفرض</label>
                    </div>
                </kt-row>
                <kt-row>
                    <div class="align-items-center mt-2 mb-5">
                        <kt-form-label>
                            {{ $t('label.change_marketing_level') }}
                        </kt-form-label>
                        <select
                                class="form-control"
                                id="marketing_level"
                                name="marketing_level"
                                v-model="marketer_specific_setting.marketing_level"
                        >
                            <option
                                    v-bind:key="index"
                                    v-for="(option, index) in options"
                                    v-bind:value="option.value"
                            >
                                {{ option.value }}
                            </option>
                        </select>
                    </div>
                </kt-row>
                <kt-form-label>
                    <h5>
                        {{ $t('marketing.marketing_setting.reports_setting') }}
                    </h5>
                </kt-form-label>
                <kt-row lg="12" md="12" xs="12" class="ml-1 mb-2">
                  <div class="custom-control custom-checkbox" id="displaying_subset_full_name-div">
                    <input
                        type="checkbox"
                        class="custom-control-input"
                        id="displaying_subset_full_name"
                        name="displaying_subset_full_name"
                        v-model="marketer_specific_setting.displaying_subset_full_name"
                    >
                    <label class="custom-control-label" id="displaying_subset_full_name" for="displaying_subset_full_name">
                      {{ $t('marketing.marketing_setting.no_displaying_subset_full_name') }}
                    </label>
                  </div>
                </kt-row>
                <kt-row lg="12" md="12" xs="12" class="ml-1 mb-2">
                  <div class="custom-control custom-checkbox" id="displaying_subsets_transaction_description-div">
                    <input
                        type="checkbox"
                        class="custom-control-input"
                        id="displaying_subsets_transaction_description"
                        name="displaying_subsets_transaction_description"
                        v-model="marketer_specific_setting.displaying_subsets_transaction_description"
                    >
                    <label class="custom-control-label" id="displaying_subsets_transaction_description"
                           for="displaying_subsets_transaction_description">
                      {{ $t('marketing.marketing_setting.no_displaying_subsets_transaction_description') }}
                    </label>
                  </div>
                </kt-row>
                <kt-row lg="12" md="12" xs="12" class="ml-1">
                    <div class="custom-control custom-checkbox" id="settlements_reports_setting-div">
                        <input
                            type="checkbox"
                            class="custom-control-input"
                            id="settlements_reports_setting"
                            name="settlements_reports_setting"
                            v-model="marketer_specific_setting.show_settlements_reports_status"
                            @change="changeLabel($event, 'disable_toggle_settlement')"
                        >
                        <label class="custom-control-label" id="settlements_reports_setting_label" for="settlements_reports_setting">
                            {{ $t('marketing.marketing_setting.showSubsetsSettlementsReportToMarketer') }}
                        </label>
                    </div>
<!--                    <div class="ml-5 custom-control custom-checkbox" id="selectAll-div">-->
<!--                        <input-->
<!--                            type="checkbox"-->
<!--                            class="custom-control-input"-->
<!--                            id="all_subsets_settlements_reports_setting"-->
<!--                            name="all_subsets_settlements_reports_setting"-->
<!--                            @change="selectAll('userSettlementsReports')"-->
<!--                        >-->
<!--                        <label class="custom-control-label" for="all_subsets_settlements_reports_setting">-->
<!--                            {{ $t('marketing.marketing_setting.selectAll') }}-->
<!--                        </label>-->
<!--                    </div>-->
                </kt-row>
                <kt-row lg="12" md="12" xs="12" :class="'ml-1 mt-3 mb-3' + ' ' + getDisableStatus(this.marketer_specific_setting.show_settlements_reports_status)"
                        id="disable_toggle_settlement"
                >
                    <kt-col lg="12" md="12" xs="12">
                        <kt-form-group>
                            <v-select
                              multiple
                              class="form-control vSelect"
                              id="userSettlementsReports"
                              name="userSettlementsReports"
                              :options="subsetOptions"
                              :filterable="false"
                              v-model="marketer_specific_setting.subsets_settlements_report"
                              @input="onSelectChange('subsets_settlements_report')"
                              @search="onSearchSubset"
                              :getOptionLabel="(option) => option.id"
                            >
                              <template slot="no-options"> کاربر مورد نظر را سرچ کنید </template>
                              <template slot="option" slot-scope="options">
                                <div class="d-flex align-items-center">
                                  {{ options.full_name }}
                                </div>
                              </template>
                              <template slot="selected-option" slot-scope="options">
                                <div class="selected d-flex align-items-center">
                                  {{ options.full_name }}
                                </div>
                              </template>
                            </v-select>
                        </kt-form-group>
                    </kt-col>
                </kt-row>
                <kt-row lg="12" md="12" xs="12" class="ml-1">
                    <div class="custom-control custom-checkbox" id="reports_setting-div">
                        <input
                                type="checkbox"
                                class="custom-control-input"
                                id="reports_setting"
                                name="reports_setting"
                                v-model="marketer_specific_setting.show_transactions_reports_status"
                                @change="changeLabel($event, 'disable_toggle')"
                        >
                        <label class="custom-control-label" id="reports_setting_label" for="reports_setting">
                            {{ $t('marketing.marketing_setting.showSubsetsTransactionsReportToMarketer') }}
                        </label>
                    </div>
                </kt-row>
                <kt-row lg="12" md="12" xs="12" :class="'ml-1 mt-3 mb-3'  + ' ' + getDisableStatus(this.marketer_specific_setting.show_transactions_reports_status)"
                        id="disable_toggle"
                >
                    <kt-col lg="6" md="6" xs="12">
                        <kt-form-group>
                            <label class="mb-3">
                                {{ $t('marketing.marketing_setting.reportFromApp') }}
                            </label>
                            <v-select
                                    multiple
                                    class="form-control vSelect"
                                    id="userReportsFromApp"
                                    name="userReportsFromApp"
                                    :options="subsetOptions"
                                    :filterable="false"
                                    v-model="marketer_specific_setting.subsets_app_report"
                                    @input="onSelectChange('subsets_app_report')"
                                    @search="onSearchSubset"
                                    :getOptionLabel="(option) => option.id"
                            >
                              <template slot="no-options"> کاربر مورد نظر را سرچ کنید </template>
                              <template slot="option" slot-scope="options">
                                <div class="d-flex align-items-center">
                                  {{ options.full_name }}
                                </div>
                              </template>
                              <template slot="selected-option" slot-scope="options">
                                <div class="selected d-flex align-items-center">
                                  {{ options.full_name }}
                                </div>
                              </template>
                            </v-select>
                        </kt-form-group>
                    </kt-col>
                    <kt-col lg="6" md="6" xs="12">
                        <kt-form-group>
                            <label class="mb-3">
                                {{ $t('marketing.marketing_setting.reportFromPSP') }}
                            </label>
                            <v-select
                                    multiple
                                    class="form-control vSelect"
                                    id="userReportsFromPSP"
                                    name="userReportsFromPSP"
                                    :options="subsetOptions"
                                    :filterable="false"
                                    v-model="marketer_specific_setting.subsets_psp_report"
                                    @input="onSelectChange('subsets_psp_report')"
                                    @search="onSearchSubset"
                                    :getOptionLabel="(option) => option.id"
                            >
                              <template slot="no-options"> کاربر مورد نظر را سرچ کنید </template>
                              <template slot="option" slot-scope="options">
                                <div class="d-flex align-items-center">
                                  {{ options.full_name }}
                                </div>
                              </template>
                              <template slot="selected-option" slot-scope="options">
                                <div class="selected d-flex align-items-center">
                                  {{ options.full_name }}
                                </div>
                              </template>
                            </v-select>
                        </kt-form-group>
                    </kt-col>
                </kt-row>
                <!--Wallet Setting-->
                <kt-row lg="12" md="12" xs="12" class="ml-1">
                  <div class="custom-control custom-checkbox" id="wallet_reports_setting-div">
                    <input
                        type="checkbox"
                        class="custom-control-input"
                        id="wallet_reports_setting"
                        name="wallet_reports_setting"
                        v-model="marketer_specific_setting.show_wallet_transactions_reports_status"
                        @change="changeLabel($event, 'disable_wallet_toggle')"
                    >
                    <label class="custom-control-label" id="wallet_reports_setting_label" for="wallet_reports_setting">
                      {{ $t('marketing.marketing_setting.showSubsetsWalletTransactionsReportToMarketer') }}
                    </label>
                  </div>
                </kt-row>
                <kt-row lg="12" md="12" xs="12" :class="'ml-1 mt-3 mb-3'  + ' ' + getDisableStatus(this.marketer_specific_setting.show_wallet_transactions_reports_status)"
                        id="disable_wallet_toggle"
                >
                  <kt-col lg="6" md="6" xs="12">
                    <kt-form-group>
                      <label class="mb-3">
                        {{ $t('marketing.marketing_setting.wallet_charge_report') }}
                      </label>
                      <v-select
                          multiple
                          class="form-control vSelect"
                          id="wallet_charge_report"
                          name="wallet_charge_report"
                          :options="subsetOptions"
                          :filterable="false"
                          v-model="marketer_specific_setting.subsets_wallet_charge_report"
                          @input="onSelectChange('subsets_wallet_charge_report')"
                          @search="onSearchSubset"
                          :getOptionLabel="(option) => option.id"
                      >
                        <template slot="no-options"> کاربر مورد نظر را سرچ کنید </template>
                        <template slot="option" slot-scope="options">
                          <div class="d-flex align-items-center">
                            {{ options.full_name }}
                          </div>
                        </template>
                        <template slot="selected-option" slot-scope="options">
                          <div class="selected d-flex align-items-center">
                            {{ options.full_name }}
                          </div>
                        </template>
                      </v-select>
                    </kt-form-group>
                  </kt-col>
                  <kt-col lg="6" md="6" xs="12">
                    <kt-form-group>
                      <label class="mb-3">
                        {{ $t('marketing.marketing_setting.wallet_settlement_report') }}
                      </label>
                      <v-select
                          multiple
                          class="form-control vSelect"
                          id="wallet_settlement_report"
                          name="wallet_settlement_report"
                          :options="subsetOptions"
                          :filterable="false"
                          v-model="marketer_specific_setting.subsets_wallet_settlement_report"
                          @input="onSelectChange('subsets_wallet_settlement_report')"
                          @search="onSearchSubset"
                          :getOptionLabel="(option) => option.id"
                      >
                        <template slot="no-options"> کاربر مورد نظر را سرچ کنید </template>
                        <template slot="option" slot-scope="options">
                          <div class="d-flex align-items-center">
                            {{ options.full_name }}
                          </div>
                        </template>
                        <template slot="selected-option" slot-scope="options">
                          <div class="selected d-flex align-items-center">
                            {{ options.full_name }}
                          </div>
                        </template>
                      </v-select>
                    </kt-form-group>
                  </kt-col>
                </kt-row>
                <!--End Wallet Setting-->
                <kt-form-label>
                    <h5>
                        <i class="text-danger fas fa-exclamation-triangle"></i>
                        <span class="px-2">{{ $t('marketing.marketing_setting.login_limit') }}</span>
                    </h5>
                </kt-form-label>
                <kt-row lg="12" md="12" xs="12" class="ml-1">
                    <div class="custom-control custom-checkbox" id="not_allowed_to_login_at_paystar-div">
                        <input
                            type="checkbox"
                            class="custom-control-input"
                            id="not_allowed_to_login_at_paystar"
                            name="not_allowed_to_login_at_paystar"
                            v-model="marketer_specific_setting.not_allowed_to_login_at_paystar"
                        >
                        <label class="custom-control-label" for="not_allowed_to_login_at_paystar">
                            {{ $t('marketing.marketing_setting.not_allowed_to_login_at_paystar') }}
                        </label>
                    </div>
                </kt-row>
                <kt-form-action class="mt-4">
                    <button class="btn btn-md btn-success btn-wide" type="submit" id="submit_btn">
                        {{ $t('btn.edit') }}
                    </button>
                </kt-form-action>
            </form>
        </kt-panel-body>
    </kt-panel>
</template>

<script>
    import $ from 'jquery'
    import { KTApp } from '@/plugins/core/app'
    import { KTUtil } from '@/plugins/core/util'
    import {marketingService} from "@/common/api.service";
    import { i18n } from '@/plugins/i18n'
    import {mapGetters} from "vuex";
    import _ from "lodash";

    export default {
        props: {
            // marketer_specific_setting: {
            //     required: true
            // },
            marketer_subsets: {
                required: true
            },
            status: {
                required: true
            }
        },
        data() {
            return {
                referral_service_enabled: null,
                options: [
                    {
                        name: 'one',
                        value: 1
                    },
                    {
                        name: 'two',
                        value: 2
                    },
                    {
                        name: 'three',
                        value: 3
                    }
                ],
                statuses: [
                    {
                        name: 'فعال',
                        value: 1
                    },
                    {
                        name: 'غیر فعال',
                        value: 0
                    }
                ],
                subsetOptions: [
                  {
                    id: 'all',
                    full_name: 'همه کاربران زیر مجموعه'
                  }
                ],
                marketer_hashid: this.$route.params.user_id,
            }
        },
        computed: {
            ...mapGetters('marketing', [
                'marketer_specific_setting'
            ]),
        },
        methods: {
            onSelectChange(key) {
                let allUsersSelected;
                switch (key) {
                    case 'subsets_app_report':
                        allUsersSelected = this.marketer_specific_setting.subsets_app_report.some(
                            (option) => option.id === 'all'
                        );
                        if (allUsersSelected) {
                            this.marketer_specific_setting.subsets_app_report =
                                this.subsetOptions.filter((option) => option.id === 'all')
                        }
                    case 'subsets_psp_report':
                        allUsersSelected = this.marketer_specific_setting.subsets_psp_report.some(
                            (option) => option.id === 'all'
                        );
                        if (allUsersSelected) {
                            this.marketer_specific_setting.subsets_psp_report =
                                this.subsetOptions.filter((option) => option.id === 'all')
                        }
                    case 'subsets_wallet_charge_report':
                        allUsersSelected = this.marketer_specific_setting.subsets_wallet_charge_report.some(
                            (option) => option.id === 'all'
                        );
                        if (allUsersSelected) {
                            this.marketer_specific_setting.subsets_wallet_charge_report =
                                this.subsetOptions.filter((option) => option.id === 'all')
                        }
                    case 'subsets_wallet_settlement_report':
                        allUsersSelected = this.marketer_specific_setting.subsets_wallet_settlement_report.some(
                            (option) => option.id === 'all'
                        );
                        if (allUsersSelected) {
                            this.marketer_specific_setting.subsets_wallet_settlement_report =
                                this.subsetOptions.filter((option) => option.id === 'all')
                        }
                    case 'subsets_settlements_report':
                        allUsersSelected = this.marketer_specific_setting.subsets_settlements_report.some(
                            (option) => option.id === 'all'
                        );
                        if (allUsersSelected) {
                            this.marketer_specific_setting.subsets_settlements_report =
                                this.subsetOptions.filter((option) => option.id === 'all')
                        }
                }
            },
            isSelected(hashid, item) {
                if (item === 'app' && this.marketer_specific_setting['subsets_app_report'])
                    return this.marketer_specific_setting['subsets_app_report'].includes(hashid);
                else if (item === 'psp' && this.marketer_specific_setting['subsets_psp_report'])
                    return this.marketer_specific_setting['subsets_psp_report'].includes(hashid);
                else if (item === 'wallet_charge' && this.marketer_specific_setting['subsets_wallet_charge_report'])
                  return this.marketer_specific_setting['subsets_wallet_charge_report'].includes(hashid);
                else if (item === 'wallet_settlement' && this.marketer_specific_setting['subsets_wallet_settlement_report'])
                  return this.marketer_specific_setting['subsets_wallet_settlement_report'].includes(hashid);

            },
            edit(e) {
                let btn = $('#submit_btn')
                let form = $('#marketer_specific_setting')

                KTApp.progress(btn)

                let params = {
                    hashid: this.$route.params.user_id,
                    profit_percent_level_1: this.marketer_specific_setting.profit_percent_level_1,
                    profit_percent_level_2: this.marketer_specific_setting.profit_percent_level_2,
                    profit_percent_level_3: this.marketer_specific_setting.profit_percent_level_3,
                    show_transactions_reports_status: this.marketer_specific_setting.show_transactions_reports_status,
                    show_settlements_reports_status: this.marketer_specific_setting.show_settlements_reports_status,
                    show_wallet_transactions_reports_status: this.marketer_specific_setting.show_wallet_transactions_reports_status,
                    subsets_for_psp_report: this.marketer_specific_setting.subsets_psp_report.map(item => item.id),
                    subsets_for_app_report: this.marketer_specific_setting.subsets_app_report.map(item => item.id),
                    subsets_for_settlements_report: this.marketer_specific_setting.subsets_settlements_report.map(item => item.id),
                    subsets_wallet_settlement_report: this.marketer_specific_setting.subsets_wallet_settlement_report.map(item => item.id),
                    subsets_wallet_charge_report: this.marketer_specific_setting.subsets_wallet_charge_report.map(item => item.id),
                    not_allowed_to_login_at_paystar: this.marketer_specific_setting.not_allowed_to_login_at_paystar,
                    displaying_subset_full_name: this.marketer_specific_setting.displaying_subset_full_name,
                    displaying_subsets_transaction_description: this.marketer_specific_setting.displaying_subsets_transaction_description,
                    custom_wage_marketing: this.$refs.custom_wage_marketing.checked,
                    marketing_level: this.marketer_specific_setting.marketing_level,
                    referral_service_enabled: this.referral_service_enabled
                }

                const serviceMethod = this.$route.params.tab === "starshop"
                    ? marketingService.changeStarshopSpecificMarketerPercentSetting
                    : marketingService.changeSpecificMarketerPercentSetting;

                serviceMethod(params)
                    .then(response => {
                        this.showMsg(form, 'success', response.data.message);
                    })
                    .catch(({ response }) => {
                        this.showMsg(form, 'danger', response.data.message);
                    })
                    .finally(() => {
                        KTUtil.scrollTop();
                        KTApp.unprogress(btn);
                    });
            },
            changeLabel(e, disableToggleId) {
                let label = $('#' + e.target.id + '_label')
                let checkbox = $('#' + e.target.id)

                if (checkbox.is(':checked')) {
                    $('#' + disableToggleId).removeClass('is-disabled')
                } else {
                    $('#' + disableToggleId).addClass('is-disabled')

                }
            },
            onSearchSubset(full_name, loading) {
              if (full_name.length > 2) {
                this.searchSubset(loading, this.marketer_hashid, full_name, this)
              }
            },
            searchSubset: _.debounce((loading, marketer_hashid, full_name, vm) => {
              if (full_name.length > 2) {
                marketingService.searchSubset(
                  full_name,
                  marketer_hashid
                )
                    .then((response) => {
                      response.data.data.forEach( item => {
                        if (! vm.subsetOptions.some(i => i.id === item.id)) {
                            vm.subsetOptions.push(item)
                        }
                      })
                      loading(false);
                    })
              }
            }, 1000),
            getDisableStatus(status) {
                if (!status)
                    return 'is-disabled';
                else
                    return '';
            },
            afterDispatch() {
                setTimeout(function () {
                    $('.kt-selectpicker').selectpicker({
                        size: 4,
                        liveSearch: true,
                        noneResultsText: i18n.t('selectpicker.none_result'),
                        selectAllText: i18n.t('selectpicker.select_all'),
                        noneSelectedText: i18n.t('selectpicker.nothing_selected')
                    })
                }, 2000)
            },
            selectAll(selectOptionsId) {
                $('#' + selectOptionsId +  'option').prop('selected', true)
            }
        },
        mounted() {
            this.referral_service_enabled = this.marketer_specific_setting.referral_service_enabled;
            this.marketer_specific_setting.subsets_app_report = this.marketer_specific_setting.subsets_app_report || []
            this.marketer_specific_setting.subsets_psp_report = this.marketer_specific_setting.subsets_psp_report || []
            this.marketer_specific_setting.subsets_wallet_charge_report = this.marketer_specific_setting.subsets_wallet_charge_report || []
            this.marketer_specific_setting.subsets_wallet_settlement_report = this.marketer_specific_setting.subsets_wallet_settlement_report || []
            this.marketer_specific_setting.subsets_settlements_report = this.marketer_specific_setting.subsets_settlements_report || []
            this.afterDispatch()
        }
    }
</script>

<style>
    .is-disabled {
        pointer-events: none;
        opacity: 0.4;
        /*display: none;*/
    }
</style>